import * as api from "../api/index";

export const ReportService = {
  getApiCampaignReportList,
  getSingelCampaignReportList,
  getCampaignNumberList,
  getFlashCampaignReportList,
  getBulkCampaignReportList,
  getFlashCampaignNumberList,
  getBulkSmsCampaignNumberList,
  getBulkCampaignNumberList,
  getPendingCampaignReportList,
  getCampaignDetailsByCampaignId,
  getAllFirstApproverCampaings,
  getAllSecondApproverCampaings,
  approveFirstApproverCampaings,
  approveSecondApproverCampaings,
};

async function approveSecondApproverCampaings(formData) {
  try {
    const { data } = await api.approveSecondApproverCampaings(
      formData
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function approveFirstApproverCampaings(formData) {
  try {
    const { data } = await api.approveFirstApproverCampaings(
      formData
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllSecondApproverCampaings(page, rowsPerPage) {
  try {
    const { data } = await api.getAllSecondApproverCampaings(
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllFirstApproverCampaings(page, rowsPerPage) {
  try {
    const { data } = await api.getAllFirstApproverCampaings(
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getApiCampaignReportList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getApiCampaignReportList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getSingelCampaignReportList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getSingelCampaignReportList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getFlashCampaignReportList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getFlashCampaignReportList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getBulkCampaignReportList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getBulkCampaignReportList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getCampaignNumberList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getCampaignNumberList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getFlashCampaignNumberList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getFlashCampaignNumberList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getBulkSmsCampaignNumberList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getBulkSmsCampaignNumberList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getBulkCampaignNumberList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getBulkCampaignNumberList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getPendingCampaignReportList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getPendingCampaignReportList(
      formData,
      page,
      rowsPerPage
    );
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getCampaignDetailsByCampaignId(formData) {
  try {
    const { data } = await api.getCampaignDetailsByCampaignId(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
